import React from "react";
import { Link } from "react-router-dom";
import { FaBuilding, FaHandHoldingHeart, FaUser } from "react-icons/fa6";

const WAYS = [
  {
    icon: FaBuilding,
    title: "Companies",
    body: "Meet your CSR commitments and build a pipeline of certified candidates. Corporate training in Nigeria may also qualify against your ITF obligations.",
  },
  {
    icon: FaHandHoldingHeart,
    title: "Foundations and development partners",
    body: "Deploy program funding into an accredited delivery partner with structured assessment and reporting you can present to your own board.",
  },
  {
    icon: FaUser,
    title: "Individuals",
    body: "Fund one seat for one learner. Every sponsored placement goes to someone in need.",
  },
];

export default function SponsorWays() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-gray-400 mb-6 flex items-center gap-3">
          <span className="block w-8 h-[2px] bg-primary" />
          Ways to sponsor
        </div>
        <h2 className="text-[#0b0f19] text-3xl md:text-5xl font-bold max-w-2xl">
          Sponsorship that fits how you give<span className="text-primary">.</span>
        </h2>

        <div className="mt-10 md:mt-14 grid gap-6 md:grid-cols-3">
          {WAYS.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="flex flex-col rounded-[10px] border border-gray-200 bg-white p-6 md:p-8 transition-colors hover:border-[#d15424]/50"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#d15424]/10 text-primary">
                <Icon size={22} />
              </span>
              <h3 className="mt-5 text-xl font-bold text-[#0b0f19]">{title}</h3>
              <p className="mt-3 text-gray-600 leading-relaxed flex-1">{body}</p>
              <Link
                to="/sponsor/participate"
                className="mt-6 text-[11px] font-bold uppercase tracking-wider text-primary hover:underline"
              >
                Become a sponsor →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
